import { render, staticRenderFns } from "./medication-section.vue?vue&type=template&id=3c4962ea"
import script from "./medication-section.vue?vue&type=script&lang=js"
export * from "./medication-section.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports